import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Link as RouterLink, useNavigate } from 'react-router-dom';

import { usePathname } from '../../hooks/usePathname';
import useAuth from '../../hooks/useAuth';

import { LogoMode } from '.';




gsap.registerEffect({
  name: "textAnimation",
  defaults: { duration: 2 },
  effect: (targets, config) => {
    return gsap
      .timeline()
      .from(
        targets,
        {
          duration: 0.5,
          opacity: 0,
          scale: 0,
          y: 80,
          rotationX: 180,
          transformOrigin: "0% 50% -50",
          ease: "back",
          stagger: 0.01,
          delay: config.delay / 25
        },
        "+=0"
      );
  }
});


const LogoModeAnimation = ({ disabledLink = false }) => {
  const navigator = useNavigate();
  const pathname = usePathname();
  const theme = useTheme();
  const { signOut } = useAuth();
  
  const ele = useRef(null);

  const handleLink = async () => {
    if(disabledLink) {
      await signOut();
    };
    if(['/honhai/app'].includes(pathname)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigator('/honhai/app');
  }

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.Sim-site-name .Sim-site-word', {
          x: 50,
          opacity: 0,
        },
        {
          delay: 0, // 0秒後
          duration: 1, // 1秒間
          x: 0,
          opacity: 1,
          ease: 'power2.easeOut',
          stagger: {
            from: 'start', // 左側
            amount: 0.5, // 0.5秒
          },
        })
    }, ele);
    return () => ctx.revert();
  }, [])
  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={1.5}
      sx={{ mr: 1, color: 'text.primary', textDecoration: 'auto', cursor: 'pointer' }}
      onClick={() => handleLink()}
    >
      <LogoMode mode={theme.palette.mode} disabledLink />

      <Box className="Sim-site-name" display={'flex'} alignItems={'center'} ref={ele}>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>中</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>央</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>總</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>務</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>服</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>務</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>平</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={theme.colors.logo.textColor}>臺</Typography>
      </Box>
    </Stack>
  )
};

export default LogoModeAnimation;
